module.exports = __webpack_public_path__ + "img/ipf2f.848cb459.svg";